import { startSurvey } from '@intercom/messenger-js-sdk';
import { useCallback } from 'react';
import { ASKABLE_INTERCOM_SURVEY } from 'shared-utils';

export const useIntercomSurvey = () => {
  return useCallback(() => startSurvey(ASKABLE_INTERCOM_SURVEY), []);
};
